export enum AVAILABLE_LANGUAGES {
  EN = 'en',
  ES_MX = 'es_mx'
}
